<template>
    <div class="header">
        <nav>
            <ul class="nav nav-pills justify-content-center">
                <li class="nav-item">
                    <router-link to="/"
                                 active-class="active"
                                 class="nav-link"
                                 exact>Home</router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/plans"
                                 active-class="active"
                                 class="nav-link">Plans</router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/contact"
                                 active-class="active"
                                 class="nav-link">Contact</router-link>
                </li>
                <li class="nav-item">
                    <a class="nav-link"
                       :href=dashboard>Dashboard</a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import { config } from 'website-core'

export default {
    data() {
        return {
            dashboard: config.url_dashboard,
        }
    },
}
</script>

<style>
.nav-link,
.nav-link:hover {
    color: #343a40;
}

.active {
    background-color: #343a40 !important;
    color: white;
}
</style>
